import React, {Component} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {addScalePoint} from "scenes/Survey/Structure/data/scalePoints/actions";
import {Input} from 'reactstrap';
import LoadingSpinner from "components/LoadingSpinner";
import {isMobile, isTablet} from "react-device-detect";
import HtmlEditor
  from "../../../../../../../../../../../../../../../../../../../../../../../componentsReusable/HtmlEditor";
import getCKConfigByPlan from "utils/ckeditor/cafeteryConfig";

class ScalePointNew extends Component {

  constructor(props) {
    super(props);

    this.state = {
      autoFocus: props.autoFocus,
      saving: false,
      adding: props.autoFocus,
      scalePoint: {
        content: ''
      }
    };

    this.onChangeContent = this.onChangeContent.bind(this);
    this.saveScalePoint = this.saveScalePoint.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  handleKeyPress(e) {
    if (e.charCode === 13)
      this.saveScalePoint()
  }

  onChangeContent(content){
    if(this.state.saving){
      return;
    }

    this.setState({
      scalePoint: {
        content
      }
    })
  }

  saveScalePoint(){
    this.setState({adding: false});
    if(this.state.saving){
      return;
    }

    const {scalePoint} = this.state;

    if(scalePoint.content.length === 0)
      return false;

    this.setState({
      scalePoint: {
        ...this.state.scalePoint,
        content: ''
      },
      saving: true
    });

    this.props.addScalePoint({
      question: this.props.question.id,
      scalePoint
    }).then(() => {
      this.setState({saving: false});
    });
  }

  render() {
    const {scalePoint, adding, saving, autoFocus} = this.state;
    const {plan} = this.props;

    const ctrlEnterKeyCode = 1114125;
    let editor;

    if (isMobile || isTablet) {
      editor = <Input value={scalePoint.content} onChange={e => this.onChangeContent(e.target.value)} onBlur={this.saveScalePoint} autoFocus={autoFocus} onKeyPress={this.handleKeyPress}/>
    } else {
      editor = <HtmlEditor
        data={scalePoint.content}
        config={getCKConfigByPlan(plan)}
        type="inline"
        onChange={event => this.onChangeContent(event)}
        onBlur={event => {
          this.saveScalePoint();
          this.setState({editing: false})
        }}
        onKey={event => {
          if (event.data.keyCode === ctrlEnterKeyCode) {
            event.cancel();
            this.saveScalePoint();
            setTimeout(() => {
              event.editor.destroy();
              this.setState({editing: false})
            }, 1);
          }
        }}
      />
    }

    return (
      <div className="line-wrap">
        <ul className="mb-0 ml-lg-5 d-flex">
          <li className="flex-grow-1">

            {adding
              ? editor
              : saving
                ? <LoadingSpinner width={21} classNames="my-0"/>
                : <small onClick={() => this.setState({adding: true, autoFocus: true})}><i><FormattedMessage id="scalePoints.scalePointNew.input.placeholder" /></i></small>
            }

          </li>
        </ul>
      </div>
    );
  }
}

ScalePointNew.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  autoFocus: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    plan: state.user.userPlan.plan
  }
}

export default connect(mapStateToProps, {addScalePoint})(ScalePointNew);